import { useContext, useState } from 'react'
import css from "./email.module.scss"
import { AuthContext } from "../../../context/auth";
import { Input } from "../../Input";
import { changeEmailApi, verifyCustomerApi } from '../../../api';

export const ChangeEmailModal = () => {
  const { setChangeEmailModal, setNotification, user, setUser, setIsLoading, login } = useContext(AuthContext)
  const [type, setType] = useState('verify-email')
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')


  const changeEmail = () => {
    setIsLoading(true)
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      if (email !== user?.customer?.email) {
        changeEmailApi({ email: email, firstName: user?.customer?.first_name, lastName: user?.customer?.last_name, id: user?.customer?.id, isSignUp: true }).then((res) => {
          if (res && res.data && res.data.customer) {
            setUser({
              ...user,
              customer: {
                ...user.customer,
                email: email,
                metadata: {
                  ...user.customer.metadata,
                  is_email_verified: false
                }
              }
            })
            setType('verify-email')
            setIsLoading(false)
          } else if (res.error.type === 'duplicate_error') {
            setNotification({
              type: 'red',
              message: 'Email already exists!'
            })
            setIsLoading(false)
          } else {
            setNotification({
              type: 'red',
              message: 'Something went wrong, please try again!'
            })
            setIsLoading(false)
          }
        }).catch((err) => {
          setNotification({
            type: 'red',
            message: 'Something went wrong, please try again!'
          })
          setIsLoading(false)
        })
      } else {
        setNotification({
          type: 'red',
          message: 'Entered email is same as current email'
        })
        setIsLoading(false)
      }
    } else {
      setNotification({
        type: 'red',
        message: 'Please enter a valid Email Address'
      })
      setIsLoading(false)
    }
  }

  const verify = () => {
    setIsLoading(true)
    verifyCustomerApi(encodeURIComponent(user?.customer?.email), code).then((res) => {
      if (res.message) {
        setNotification({
          type: 'red',
          message: res.message.message
        })

      } else {
        setNotification({
          type: 'email',
          message: 'Email Address Verified!'
        })
        setUser(res.data)
        setChangeEmailModal(false)
      }
      setIsLoading(false)
    }).catch((err) => {
      setIsLoading(false)
      setNotification({
        type: 'red',
        message: 'Invalid verification code!'
      })
    })
  }



  return (
    <div className={css.modalWrapper}>
      <div className={`${css.modalContent} ${type === 'verify-email' && css.verifyModalContent}`} style={{ padding: '20px' }}>
        <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
          <span className={css.icon}>
            <i class="fal fa-envelope"></i>
          </span>
          <span className={css.closeIcon} onClick={() => setChangeEmailModal(false)}><i className="fal fa-times"></i></span>
        </div>
        {type === 'change-email' ? <>
          <h2>Change Email </h2>
          <h4 style={{ marginBottom: '12px' }}>Enter new email below</h4>
          <Input placeholder="Enter new email here" type='email' value={email} onChange={(e) => setEmail(e.target.value)} style={{ marginBottom: '20px', textAlign: 'center' }} />
          <button className={`btn ${css.ctaBtn}`} disabled={!email} onClick={() => {
            changeEmail()
          }}>Continue</button>
          <button className={`btn ${css.transparentBtn}`} onClick={() => {
            setChangeEmailModal(false)
          }}>Cancel</button>
        </>
          :
          <>
            <h2>Verify Your Email Address </h2>
            <p>A verification code was set to {user?.customer?.email}.</p>
            <p>This code will be valid for 10 minutes.</p>
            <h4>Enter the code Below</h4>
            <Input placeholder="XXXX" type='text' style={{ marginBottom: '20px', textAlign: 'center' }}
              onChange={(e) => setCode(e.target.value)}
              value={code}
            />
            <p className={css.alignLeft}>If you dont see the email in a few minutes, please try the following:</p>
            <div className={css.details}>
              <ul>
                <li>Add no-reply@identifyn.com to your Whitelist or Safe Sender List</li>
                <li>Check your junk mail or spam folder</li>
                <li>If this email address is not valid please <span className={css.link} onClick={() => {
                  setType('change-email')
                }}>provide one here</span></li>
              </ul>
            </div>
            <p style={{ textAlign: 'center', marginBottom: '20px' }}>Didn't get a code? <span className={css.link}
              onClick={() => {
                changeEmail()
              }}
            >Resend</span></p>
            <button className={`btn ${css.ctaBtn}`} disabled={!code} onClick={() => {
              verify()
            }}>Verify</button>
            <button className={`btn ${css.transparentBtn}`} onClick={() => {
              setChangeEmailModal(false)
            }}>Cancel</button>
          </>
        }
      </div>
    </div>
  )
}